var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMxFuel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 97.604 61.035"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M87.368 61.035H3.869A3.875 3.875 0 0 1 0 57.155V3.879A3.874 3.874 0 0 1 3.869 0h83.5a3.875 3.875 0 0 1 3.869 3.88v53.275a3.875 3.875 0 0 1-3.869 3.88"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  fillRule: "evenodd",
  d: "M23.808 41.197v3.056H10.954c-.643 0-.724.482-.724 1v.386h13.578v3.072H10.246v4.392h-3.1v-8.094a3.76 3.76 0 0 1 3.812-3.812ZM44.434 41.197h-3.071l-.015 7.947c0 .435 0 .837-.7.837h-9.117c-.624 0-.7-.418-.7-1v-7.784h-3.057v8.3a3.487 3.487 0 0 0 3.774 3.6h12.89ZM84.114 53.1v-3.121H72.129c-.645 0-.728-.418-.728-1v-7.782h-3.158v8.3c0 2.219 1.62 3.6 3.9 3.6ZM64.276 41.197v3.056H51.424c-.643 0-.724.482-.724 1v.386h13.575v3.072h-13.56v.274c0 .579.081 1.014.708 1.014h12.852v3.1H51.424a3.59 3.59 0 0 1-3.813-3.78v-4.31a3.76 3.76 0 0 1 3.813-3.812Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#db031d",
  fillRule: "evenodd",
  d: "M7.142 7.869h14.68l4.327 15.22h.073l4.327-15.22h14.682v26.187h-9.467v-18.7h-.073l-5.548 18.7H22.23l-5.548-18.7h-.074v18.7H7.142Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  fillRule: "evenodd",
  d: "M59.635 20.939 46.818 7.869h12.811l5.837 6.819 5.832-6.819h12.816l-12.789 13.07 12.719 13.116H71.325l-5.859-5.871-5.831 5.871H46.883Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M92.92 59.095h-.871v-.44h2.382v.44h-.871v1.94h-.639ZM95.223 58.655h.684l.517 1.637h.006l.489-1.637h.684v2.381h-.455v-1.687h-.006l-.542 1.687h-.375l-.542-1.67h-.006v1.67h-.455Z"
})));
export default SvgMxFuel;